module.exports = __webpack_public_path__ + "img/topmain.02e454a.png";